"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Config = void 0;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Layer = /*#__PURE__*/function () {
  _createClass(Layer, [{
    key: "name",
    value: function name() {
      return this._name;
    }
  }, {
    key: "parent",
    value: function parent() {
      return this._parent;
    }
  }, {
    key: "content",
    value: function content() {
      return JSON.parse(JSON.stringify(this._content));
    }
  }]);

  function Layer(parent, name, content) {
    _classCallCheck(this, Layer);

    _defineProperty(this, "_name", void 0);

    _defineProperty(this, "_parent", void 0);

    _defineProperty(this, "_content", void 0);

    this._name = name;
    this._parent = parent || this;
    this._content = content;
  }

  _createClass(Layer, [{
    key: "set",
    value: function set(key, value) {
      return this._content[key] = value;
    }
  }, {
    key: "get",
    value: function get(key) {
      if (this._content.hasOwnProperty(key)) {
        return this._content[key];
      } else if (this._parent !== this) {
        return this._parent.get(key);
      } else {
        return null;
      }
    }
  }, {
    key: "snapshot",
    value: function snapshot() {
      if (this._parent === this) {
        return this.content();
      } else {
        return _objectSpread(_objectSpread({}, this._parent.content()), this.content());
      }
    }
  }]);

  return Layer;
}();

var Config = /*#__PURE__*/function () {
  function Config(config) {
    _classCallCheck(this, Config);

    _defineProperty(this, "_layer", void 0);

    this._layer = new Layer(null, 'base', config);
  }

  _createClass(Config, [{
    key: "pushLayer",
    value: function pushLayer(name, config) {
      this._layer = new Layer(this._layer, name, config);
    }
  }, {
    key: "popLayer",
    value: function popLayer() {
      var layer = this._layer;
      this._layer = layer.parent();
      return layer;
    }
  }, {
    key: "set",
    value: function set(key, value) {
      return this._layer.set(key, value);
    }
  }, {
    key: "get",
    value: function get(key) {
      return this._layer.get(key);
    }
  }, {
    key: "snapshot",
    value: function snapshot() {
      return this._layer.snapshot();
    }
  }]);

  return Config;
}();

exports.Config = Config;


//////////////////
// WEBPACK FOOTER
// ./~/@weike/toolkit/lib/config/config.js
// module id = 617
// module chunks = 6